// React
import { ReactElement } from 'react';
// Next
import { useTranslation } from 'next-i18next';
// Utils
//import { saveSvgAsPng } from 'save-svg-as-png';
// Design System
import { Font } from '@utmb/design-system/text/font';
// Features
import { RaceTrackIcon } from '@utmb/features/race-track/RaceTrackIcon';
import { COLOR_LIGHT_GREY, SVG_ID_SVG } from '@utmb/features/race-track/profile/RaceProfile';
// Styles
import styles from './race-profile.module.scss';
import { useRaceTrack } from '@utmb/contexts/RaceTrackContext';
import { useRouter } from 'next/router';

const toFileName = (name: string) => name.replace(/[^a-z0-9]/gi, '_').toLowerCase();

export const RaceProfileDownload = (): ReactElement => {
    const { t } = useTranslation();
    /* eslint-disable @typescript-eslint/no-var-requires */
    const svg2png = require('@utmb/design-system/types/saveSvgAsPng');
    const { name } = useRaceTrack();

    const {
        query: { scale, bgcolor },
    } = useRouter();

    const handleDownload = (): void => {
        const imageOptions = {
            scale: scale ?? 2,
            encoderOptions: 1,
            backgroundColor: bgcolor ?? COLOR_LIGHT_GREY,
            excludeUnusedCss: true,
        };

        svg2png.saveSvgAsPng(document.getElementById(SVG_ID_SVG), `${toFileName(name)}.png`, imageOptions);
    };

    return (
        <button className={styles.filter_button} onClick={handleDownload}>
            <RaceTrackIcon icon="download" color="var(--utmb-color-white)" />
            <Font.FuturaHeavy className={styles.export_btn_label} mobile="16">
                {t('raceTrack.service.download')}
            </Font.FuturaHeavy>
        </button>
    );
};

export const RaceGpxDownload = (): ReactElement => {
    const { t } = useTranslation();

    const { gpxUrl } = useRaceTrack();

    return (
        <a className={styles.filter_anchor} href={gpxUrl} download>
            <RaceTrackIcon icon="download" color="var(--utmb-color-white)" />
            <Font.FuturaHeavy className={styles.export_btn_label} mobile="16">
                {t('raceTrack.service.downloadGpx')}
            </Font.FuturaHeavy>
        </a>
    );
};
